import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FadeIn } from './ui/FadeIn';
import { ChevronDownIcon } from 'lucide-react';
interface FAQItemProps {
  question: string;
  answer: string;
  isOpen: boolean;
  onClick: () => void;
}
function FAQItem({
  question,
  answer,
  isOpen,
  onClick
}: FAQItemProps) {
  return <div className="border-b border-sage/20 last:border-0" data-id="element-27">
      <button className="w-full py-6 flex items-center justify-between text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-sage rounded-lg px-2" onClick={onClick} aria-expanded={isOpen} data-id="element-28">
        <span className="font-serif text-xl text-charcoal font-medium pr-8" data-id="element-29">
          {question}
        </span>
        <ChevronDownIcon className={`w-6 h-6 text-sage transition-transform duration-300 flex-shrink-0 ${isOpen ? 'rotate-180' : ''}`} data-id="element-30" />
      </button>
      <AnimatePresence data-id="element-31">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} className="overflow-hidden" data-id="element-32">
            <p className="pb-6 px-2 text-muted text-lg leading-relaxed" data-id="element-33">
              {answer}
            </p>
          </motion.div>}
      </AnimatePresence>
    </div>;
}
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    question: '¿Es seguro anotar mis claves aquí?',
    answer: 'Sí, siempre que guarde el documento físico en un lugar seguro que solo sus hijos conozcan.'
  }, {
    question: '¿Necesito una computadora?',
    answer: 'No, puede imprimirlo y llenarlo a mano de forma tradicional.'
  }, {
    question: '¿Cuánto tiempo toma?',
    answer: 'Está diseñado para completarse poco a poco. Puede terminarlo en un fin de semana sin prisas.'
  }];
  return <section className="py-20 md:py-32 px-6 bg-sage-light" data-id="element-34">
      <div className="max-w-3xl mx-auto" data-id="element-35">
        <FadeIn data-id="element-36">
          <h2 className="font-serif text-3xl md:text-4xl text-charcoal mb-12 text-center" data-id="element-37">
            Preguntas Frecuentes
          </h2>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-38">
          <div className="bg-card rounded-2xl p-6 md:p-8 shadow-sm border border-sage/10" data-id="element-39">
            {faqs.map((faq, index) => <FAQItem key={index} question={faq.question} answer={faq.answer} isOpen={openIndex === index} onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-40" />)}
          </div>
        </FadeIn>
      </div>
    </section>;
}